// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"62":"229956b1","99":"61784813","189":"992a1d48","284":"62b80d92","316":"5caa1d8d","462":"c88b13e1","488":"308be2d1","683":"efe70973","796":"3ec5b2fe","837":"b36050da","977":"9d51e6af"}[chunkId] + ".chunk.js";
};